import { gql } from 'apollo-angular';

export const groupSelectOptionsQuery = gql`
  query GroupSelectOptions {
    groupList {
      id
      name
      properties {
        id
      }
    }
  }
`;

export const groupSelectOptionsWImageQuery = gql`
  query GroupSelectOptionsWImage {
    groupList {
      id
      name
      imgUrl
    }
  }
`;
